import { Box, Container, Grid, Typography } from "@mui/material";
import TradingDetailsBox from "./Utilities/TradingDetailsBox";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const RegulationAndLicence = () => {
  return (
      <>

      <Helmet>
        <link rel="canonical" href="https://www.hcfinvest.com/regulationAndLicence" />
      </Helmet>

              <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
      <ScrollToTopButton />

      {/* Banner */}
      <Box
        className="page-hero"
        sx={{
          height: { xs: "280px", sm: "350px", md: "475px" },
          backgroundImage: `url('/Images/RegulationsImages/Newhedgecapitalsimage_regulations.jpg')`,
          marginBottom: "30px",
        }}
      >
        <div className="page-hero-content">
          <h1 className="page-hero-title">Regulation &amp; Licence</h1>
          <p className="page-hero-subtitle">
            Fully Licensed &amp; Regulated by the Financial Services Authority (FSA)
          </p>
        </div>
      </Box>

      {/* MAIN SECTION */}
      <Box sx={{ py: { xs: 5, md: 7 }, backgroundColor: "#f9fafc" }}>
        <Container maxWidth="lg">
          {/* Heading */}
          <Box className="text-center mb-5">
            <Typography
              variant="h3"
              className="fw-bold"
              sx={{ color: "#172543", fontSize: { xs: "1.75rem", md: "2.25rem" } }}
            >
              Group Licenses
            </Typography>
            <Box
              sx={{
                width: "60px",
                height: "4px",
                background: "linear-gradient(135deg, #5b8def 0%, #9fc3ff 100%)",
                borderRadius: "2px",
                mx: "auto",
                mt: 2,
              }}
            />
          </Box>

          {/* License Card */}
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              border: "1px solid #f0f0f0",
              boxShadow: "0 8px 30px rgba(23, 37, 67, 0.08)",
              overflow: "hidden",
            }}
          >
            <Grid container>
              {/* Left: Jurisdiction */}
              <Grid
                item
                size={{ xs: 12, md: 4 }}
                sx={{
                  background: "linear-gradient(135deg, #172543 0%, #3a5aa8 100%)",
                  color: "#fff",
                  p: { xs: 4, md: 5 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  component="img"
                  src="/Images/RegulationsImages/Saint-Vincent-Grenadines-flag.webp"
                  alt="Flag of Saint Vincent and the Grenadines"
                  sx={{
                    width: "110px",
                    height: "110px",
                    objectFit: "cover",
                    borderRadius: "50%",
                    border: "4px solid rgba(255,255,255,0.25)",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
                    mb: 2,
                  }}
                />
                <Typography sx={{ fontWeight: 700, fontSize: "1.1rem", mb: 0.5 }}>
                  Saint Vincent &amp; the Grenadines
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.8)" }}>
                  Financial Services Authority (FSA)
                </Typography>
                <Box
                  sx={{
                    mt: 2.5,
                    px: 2.5,
                    py: 0.75,
                    borderRadius: "999px",
                    backgroundColor: "rgba(255,255,255,0.12)",
                    border: "1px solid rgba(255,255,255,0.25)",
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                  }}
                >
                  Registration No. 3970
                </Box>
              </Grid>

              {/* Right: Details */}
              <Grid item size={{ xs: 12, md: 8 }} sx={{ p: { xs: 3, md: 5 } }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: "#172543", mb: 2 }}
                >
                  Heddge Capitals Wealth Management LLC
                </Typography>

                <Grid container spacing={2} sx={{ mb: 3 }}>
                  {[
                    { label: "Trading Name", value: "HC Finvest" },
                    { label: "Regulator", value: "Financial Services Authority (FSA)" },
                    { label: "Jurisdiction", value: "St. Vincent and the Grenadines" },
                    { label: "Registration No.", value: "3970" },
                  ].map((row) => (
                    <Grid item size={{ xs: 12, sm: 6 }} key={row.label}>
                      <Typography sx={{ fontSize: "0.8rem", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        {row.label}
                      </Typography>
                      <Typography sx={{ fontWeight: 600, color: "#172543" }}>
                        {row.value}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>

                <Typography sx={{ color: "#555", lineHeight: 1.8, mb: 2 }}>
                  <strong>Heddge Capitals Wealth Management LLC</strong>, operating under the brand name{" "}
                  <strong>HC Finvest</strong>, is a legally registered company under the Financial Services
                  Authority (FSA) in St. Vincent and the Grenadines with registration number 3970, in
                  accordance with the Companies Act, Chapter 151 of the Revised Laws of St. Vincent and
                  the Grenadines, 2001. As a registered entity, we are authorized to provide forex trading
                  services globally, ensuring compliance with the laws governing international financial
                  services.
                </Typography>

                <Typography sx={{ color: "#555", lineHeight: 1.8 }}>
                  The objects of the Company are all subject matters not forbidden by the International
                  Business Companies (Amendment and Consolidation) Act, Chapter 149 of the Revised Laws of
                  Saint Vincent and Grenadines, 2009. These include, but are not limited to, commercial,
                  financial, lending, borrowing, trading, service activities, participation in other
                  enterprises, and the provision of brokerage, training, and managed account services in
                  currencies, commodities, indexes, CFDs, and leveraged financial instruments.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>

      <TradingDetailsBox />
    </Container>
      </>
  );
};

export default RegulationAndLicence;
